import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import EditableRichText from '../../../../../src/web/containers/EditableRichText';
import Button from '../../../../../modules/react/components/stateless/Button';
import styles from './styles.scss';

const propTypes = {
  thankYouHeaderText: PropTypes.string.isRequired,
  thankYouBodyContent: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  thankYouButtonText: PropTypes.string.isRequired,
  onClose: PropTypes.func,
};

const defaultProps = {
  onClose: undefined,
};

const attrs = [
  'thankYouHeaderText',
  'thankYouBodyContent',
  'thankYouButtonText',
  'onClose',
];

const ThankYouBody = ({
  thankYouHeaderText,
  thankYouBodyContent,
  thankYouButtonText,
  onClose,
}) => (
  <div>
    <Row>
      <Col xs={12}>
        <div className={`color-primary-foreground ${styles.thankYouHeader}`}>
          {thankYouHeaderText}
        </div>
      </Col>
    </Row>
    <Row>
      <Col xs={12}>
        <EditableRichText rawContentState={thankYouBodyContent} />
      </Col>
    </Row>
    <Row>
      <Col xs={12}>
        <div className={styles.thankYouButton}>
          <Button
            variant="success"
            className="color-secondary-background color-primary-background-hover button-style-class"
            onClick={onClose}
          >
            {thankYouButtonText}
          </Button>
        </div>
      </Col>
    </Row>
  </div>
);

ThankYouBody.propTypes = propTypes;
ThankYouBody.defaultProps = defaultProps;
ThankYouBody.attrs = attrs;

export default ThankYouBody;
